import React, { useEffect, useRef, useState } from "react";
import Utils from "../constant/Utils";
import * as api from "../constant/NewAPI";
import Select from "react-select";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import FatigueGraph from "./FatigueGraph";
import JointStiffnessGraph from "./JointStiffnessGraph";
import MentalReadinessGraph from "./MentalReadiness";
import MuscleSorenessGraph from "./MuscleSoreness";
import SleepQualityGraph from "./SleepQuality";

const DailyCheckIn = () => {

    const [instituteId, setInstituteId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [date, setDate] = useState("");
    const [sleepQuality, setSleepQuality] = useState("");
    const [muscleSoreness, setMuscleSoreness] = useState("");
    const [fatigueLvl, setFatigueLvl] = useState("");
    const [jointStiffness, setJointStiffness] = useState("");
    const [mentalReadiness, setMentalReadiness] = useState("");
    const [athleteName, setAthleteName] = useState("");
    const [institutionList, setInstitutionList] = useState([]);
    const [athleteList, setAthleteList] = useState([]);
    const [metricScaleList, setMetricScaleList] = useState([]);
    const [metricData, setMetricData] = useState([]);
    const [recentData, setRecentData] = useState([]);
    const [showRecentValues, setShowRecentValues] = useState(false);
    const [showAvgValues, setShowAvgValues] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [showMetric, setShowMetric] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const formRef = useRef(null);

    const roleId = localStorage.getItem("RoleId");
    const userId = localStorage.getItem("UserId");

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    // Helper for date → DD-MM-YYYY
    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        if (roleId == "1" || roleId == "6" || roleId == "5") {
            institutes();
        } else if (roleId == "8") {
            fetchmetricData(null)
        }
    }, [])

    function institutes() {
        const getInstList = api.GeneralInstituteList + '/' + roleId;
        fetch(getInstList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == true) {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (result.data != null) {
                        setInstitutionList(result.data);
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            })
    }

    function listAthletes(inst) {
        const athlts = api.HPCAthletes + "/" + inst;
        fetch(athlts, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == true) {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (result.data != null) {
                        setAthleteList(result.data);
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            })
    }

    function metricScale() {
        const mtrc = api.MetricScale;
        fetch(mtrc, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == true) {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (result.data != null) {
                        setMetricScaleList(result.data);
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            })
    }

    function fetchmetricData(athlt) {
        const formData = new FormData();
        formData.append("athleteId", athlt);

        const mtrc = api.MetricData;
        fetch(mtrc, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == true) {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Alert!!',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                } else {
                    if (result.data != null) {
                        setMetricData(result.data);
                        setRecentData(result.data.recentData);
                        setShowMetric(true);
                        setShowRecentValues(true);
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            })
    }

    function changeValues(ischecked) {
        if (ischecked) {
            setRecentData(metricData.weeklyAvg)
            setShowAvgValues(true);
            setShowRecentValues(false);
        } else {
            setRecentData(metricData.recentData)
            setShowAvgValues(false);
            setShowRecentValues(true);
        }
    }

    function addDailyCheckin() {
        if (roleId == "8") {
            metricScale();
        }
        setOpenModal(true);
        setIsEdit(false);
        setAthleteId("")
        setDate("")
        setSleepQuality("")
        setMuscleSoreness("")
        setFatigueLvl("")
        setJointStiffness("")
        setMentalReadiness("")
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            const formData = new FormData();
            if (roleId == "1" || roleId == "6" || roleId == "5") {
                formData.append("athleteId", athleteId);
            }
            formData.append("date", date);
            formData.append("sleepQuality", sleepQuality);
            formData.append("muscleSoreness", muscleSoreness);
            formData.append("fatigueLevel", fatigueLvl);
            formData.append("jointStiffness", jointStiffness);
            formData.append("mentalReadiness", mentalReadiness);

            const addChkin = api.DailyCheckin;
            fetch(addChkin, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((scdlResponse) => scdlResponse.json())
                .then((result) => {
                    setIsLoading(false);
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.log("Failed to create new Schedule", error)
                })
        }
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h4 className="text-center mb-40">Daily Checkin</h4>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="row col-md-12">
                                                            <div className="row col-md-12">

                                                                {(roleId == "1" || roleId == "5" || roleId == '6' || roleId == '8') && (
                                                                    <>
                                                                        <div className="col-md-4">
                                                                            <Link
                                                                                to="#"
                                                                                className="btn btn-secondary"
                                                                                onClick={() => addDailyCheckin()}>

                                                                                <i className="feather-plus" />&nbsp;
                                                                                Add                                                                            </Link>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                            <div className="col-lg-12"></div>
                                                            <div className="col-lg-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                            {(roleId == "1" || roleId == "6" || roleId == "5") && (
                                                                <>
                                                                    <div className="row col-lg-12 court-sortby sortbyset mb-10">
                                                                        <div className="col-lg-3 mb-10">
                                                                            <label className="sortbytitle"><h6>Institute</h6></label>
                                                                            <Select
                                                                                value={institutionList.find(ins => ins.institutionId === instituteId) ? {
                                                                                    value: instituteId,
                                                                                    label: institutionList.find(ins => ins.institutionId === instituteId).institutionName
                                                                                } : null}
                                                                                onChange={(e) => {
                                                                                    setInstituteId(e.value);
                                                                                    listAthletes(e.value)
                                                                                }}
                                                                                options={institutionList.map(ins => ({
                                                                                    value: ins.institutionId,
                                                                                    label: ins.institutionName
                                                                                }))}>
                                                                            </Select>
                                                                        </div>
                                                                        <div className="col-lg-3 mb-10">
                                                                            <label className="sortbytitle"><h6>Athlete</h6></label>
                                                                            <Select
                                                                                value={athleteList.find(atlt => atlt.coreLoginUserId === athleteId) ? {
                                                                                    value: athleteId,
                                                                                    label: athleteList.find(atlt => atlt.coreLoginUserId === athleteId).coreLoginUsername
                                                                                } : null}
                                                                                onChange={(e) => {
                                                                                    setAthleteId(e.value);
                                                                                    setAthleteName(e.label)
                                                                                    setShowMetric(false)
                                                                                    setShowAvgValues(false);
                                                                                    setShowRecentValues(false);
                                                                                    fetchmetricData(e.value);
                                                                                }}
                                                                                required
                                                                                options={athleteList.map(atlt => ({
                                                                                    value: atlt.coreLoginUserId,
                                                                                    label: atlt.coreLoginUsername
                                                                                }))}>
                                                                            </Select>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}

                                                            {showMetric && (
                                                                <>
                                                                    {(roleId == "1" || roleId == "6" || roleId == "5") && (
                                                                        <div className="statistics-grid d-flex justify-content-center" style={{ padding: "10px" }}>
                                                                            <h4>{athleteName} <span>-</span> Monthly Metrics</h4>
                                                                        </div>
                                                                    )}
                                                                    <div className="row mb-10 justify-space-between">
                                                                        <div className="col-lg-4 mb-10">
                                                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                                                <h6 className="text-center">Fatigue</h6>
                                                                                <FatigueGraph allData={metricData} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 mb-10">
                                                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                                                <h6 className="text-center">Joint Stiffness</h6>
                                                                                <JointStiffnessGraph allData={metricData} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 mb-10">
                                                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                                                <h6 className="text-center">Mental Readiness</h6>
                                                                                <MentalReadinessGraph allData={metricData} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 mb-10">
                                                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                                                <h6 className="text-center">Muscle Soreness</h6>
                                                                                <MuscleSorenessGraph allData={metricData} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 mb-10">
                                                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                                                <h5 className="text-center">Sleep Quality</h5>
                                                                                <SleepQualityGraph allData={metricData} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="statistics-grid row align-items-center" style={{ padding: "10px" }}>
                                                                        <div className="col d-flex justify-content-between align-items-center">
                                                                            <h4 style={{ visibility: showRecentValues ? "visible" : "hidden" }}>
                                                                                Latest Metrics: {(recentData != 0) ? formatDate(recentData.date) : "No Data Available"}
                                                                            </h4>
                                                                            <div className="form-check form-switch d-flex align-items-end justify-content-end">
                                                                                <label>Want to know weekly average?</label>
                                                                                <input
                                                                                    className="form-check-input text-end"
                                                                                    type="checkbox"
                                                                                    id="toggle"
                                                                                    onChange={(e) => {
                                                                                        changeValues(e.target.checked)
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {showRecentValues && (
                                                                        <>
                                                                            <div className="row">
                                                                                <div className="col-lg-2">
                                                                                    <div className="statistics-grid justify-content-center">
                                                                                        <div className="listing-content text-center">
                                                                                            <div className="listing title">
                                                                                                <h3>Fatigue Level</h3>
                                                                                                <p className="text-center">{(recentData != 0) ? recentData.fatigueLevelName : "No Data Available"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <div className="statistics-grid justify-content-center">
                                                                                        <div className="listing-content text-center">
                                                                                            <div className="listing title">
                                                                                                <h3>Joint Stiffness</h3>
                                                                                                <p className="text-center">{(recentData != 0) ? recentData.jointStiffnessName : "No Data Available"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <div className="statistics-grid justify-content-center">
                                                                                        <div className="listing-content text-center">
                                                                                            <div className="listing title">
                                                                                                <h3>Mental Readiness</h3>
                                                                                                <p className="text-center">{(recentData != 0) ? recentData.mentalReadinessName : "No Data Available"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <div className="statistics-grid justify-content-center">
                                                                                        <div className="listing-content text-center">
                                                                                            <div className="listing title">
                                                                                                <h3>Muscle Soreness</h3>
                                                                                                <p className="text-center">{(recentData != 0) ? recentData.muscleSorenessName : "No Data Available"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <div className="statistics-grid justify-content-center">
                                                                                        <div className="listing-content text-center">
                                                                                            <div className="listing title">
                                                                                                <h3>Sleep Quality</h3>
                                                                                                <p className="text-center">{(recentData != 0) ? recentData.sleepQualityName : "No Data Available"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                    {showAvgValues && (
                                                                        <>
                                                                            <div className="row">
                                                                                <div className="col-lg-2">
                                                                                    <div className="statistics-grid justify-content-center">
                                                                                        <div className="listing-content text-center">
                                                                                            <div className="listing title">
                                                                                                <h3>Fatigue Level</h3>
                                                                                                <p className="text-center">{(recentData.fatigueLevelName != null) ? recentData.fatigueLevelName : "No Data Available"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <div className="statistics-grid justify-content-center">
                                                                                        <div className="listing-content text-center">
                                                                                            <div className="listing title">
                                                                                                <h3>Joint Stiffness</h3>
                                                                                                <p className="text-center">{(recentData.jointStiffnessName != null) ? recentData.jointStiffnessName : "No Data Available"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <div className="statistics-grid justify-content-center">
                                                                                        <div className="listing-content text-center">
                                                                                            <div className="listing title">
                                                                                                <h3>Mental Readiness</h3>
                                                                                                <p className="text-center">{(recentData.mentalReadinessName != null) ? recentData.mentalReadinessName : "No Data Available"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <div className="statistics-grid justify-content-center">
                                                                                        <div className="listing-content text-center">
                                                                                            <div className="listing title">
                                                                                                <h3>Muscle Soreness</h3>
                                                                                                <p className="text-center">{(recentData.muscleSorenessName != null) ? recentData.muscleSorenessName : "No Data Available"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <div className="statistics-grid justify-content-center">
                                                                                        <div className="listing-content text-center">
                                                                                            <div className="listing title">
                                                                                                <h3>Sleep Quality</h3>
                                                                                                <p className="text-center">{(recentData.sleepQualityName != null) ? recentData.sleepQualityName : "No Data Available"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Daily Check-in Modal */}
            <Modal
                show={openModal}
                centered
                size="xl">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Create "}Daily Check-in</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => { setOpenModal(false); }}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            {(roleId == "1" || roleId == "6" || roleId == "5") && (
                                <>
                                    <div className="col-lg-3 mb-10">
                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                        <Select
                                            value={institutionList.find(ins => ins.institutionId === instituteId) ? {
                                                value: instituteId,
                                                label: institutionList.find(ins => ins.institutionId === instituteId).institutionName
                                            } : null}
                                            onChange={(e) => {
                                                setInstituteId(e.value);
                                                listAthletes(e.value)
                                            }}
                                            styles={customSelect}
                                            required
                                            options={institutionList.map(ins => ({
                                                value: ins.institutionId,
                                                label: ins.institutionName
                                            }))}>
                                        </Select>
                                    </div>
                                    <div className="col-lg-3 mb-10">
                                        <label className="sortbytitle"><h6>Athletes</h6></label>
                                        <Select
                                            value={athleteList.find(atlt => atlt.coreLoginUserId === athleteId) ? {
                                                value: athleteId,
                                                label: athleteList.find(atlt => atlt.coreLoginUserId === athleteId).coreLoginUsername
                                            } : null}
                                            onChange={(e) => {
                                                setAthleteId(e.value);
                                                metricScale();
                                            }}
                                            styles={customSelect}
                                            required
                                            options={athleteList.map(atlt => ({
                                                value: atlt.coreLoginUserId,
                                                label: atlt.coreLoginUsername
                                            }))}>
                                        </Select>
                                    </div>
                                </>
                            )}
                            <div className="col-lg-3 mb-10">
                                <label className="sortbytitle">Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    required
                                    name="date"
                                    value={date}
                                    onChange={(e) => { setDate(e.target.value) }}
                                    placeholder="Enter Date" />
                            </div>
                            <div className="col-lg-3 mb-10">
                                <label className="sortbytitle">Sleep Quality</label>
                                <Select
                                    value={metricScaleList.find(mtrc => mtrc.metricScaleId === sleepQuality) ? {
                                        value: sleepQuality,
                                        label: metricScaleList.find(mtrc => mtrc.metricScaleId === sleepQuality).sleepQuality
                                    } : null}
                                    onChange={(e) => {
                                        setSleepQuality(e.value);
                                    }}
                                    styles={customSelect}
                                    required
                                    options={metricScaleList.map(mtrc => ({
                                        value: mtrc.metricScaleId,
                                        label: mtrc.sleepQuality
                                    }))}>
                                </Select>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <label className="sortbytitle">Muscle Soreness</label>
                                <Select
                                    value={metricScaleList.find(mtrc => mtrc.metricScaleId === muscleSoreness) ? {
                                        value: muscleSoreness,
                                        label: metricScaleList.find(mtrc => mtrc.metricScaleId === muscleSoreness).muscleSoreness
                                    } : null}
                                    onChange={(e) => {
                                        setMuscleSoreness(e.value);
                                    }}
                                    styles={customSelect}
                                    required
                                    options={metricScaleList.map(mtrc => ({
                                        value: mtrc.metricScaleId,
                                        label: mtrc.muscleSoreness
                                    }))}>
                                </Select>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <label className="sortbytitle">Fatigue Level</label>
                                <Select
                                    value={metricScaleList.find(mtrc => mtrc.metricScaleId === fatigueLvl) ? {
                                        value: fatigueLvl,
                                        label: metricScaleList.find(mtrc => mtrc.metricScaleId === fatigueLvl).fatigueLevel
                                    } : null}
                                    onChange={(e) => {
                                        setFatigueLvl(e.value);
                                    }}
                                    styles={customSelect}
                                    required
                                    options={metricScaleList.map(mtrc => ({
                                        value: mtrc.metricScaleId,
                                        label: mtrc.fatigueLevel
                                    }))}>
                                </Select>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <label className="sortbytitle">Joint Stiffness</label>
                                <Select
                                    value={metricScaleList.find(mtrc => mtrc.metricScaleId === jointStiffness) ? {
                                        value: jointStiffness,
                                        label: metricScaleList.find(mtrc => mtrc.metricScaleId === jointStiffness).jointStiffness
                                    } : null}
                                    onChange={(e) => {
                                        setJointStiffness(e.value);
                                    }}
                                    styles={customSelect}
                                    required
                                    options={metricScaleList.map(mtrc => ({
                                        value: mtrc.metricScaleId,
                                        label: mtrc.jointStiffness
                                    }))}>
                                </Select>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <label className="sortbytitle">Mental Readiness</label>
                                <Select
                                    value={metricScaleList.find(mtrc => mtrc.metricScaleId === mentalReadiness) ? {
                                        value: mentalReadiness,
                                        label: metricScaleList.find(mtrc => mtrc.metricScaleId === mentalReadiness).mentalReadiness
                                    } : null}
                                    onChange={(e) => {
                                        setMentalReadiness(e.value);
                                    }}
                                    styles={customSelect}
                                    required
                                    options={metricScaleList.map(mtrc => ({
                                        value: mtrc.metricScaleId,
                                        label: mtrc.mentalReadiness
                                    }))}>
                                </Select>
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />{isEdit ? "Update " : "Save "}</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal >
            {/* /Daily Check-in Modal */}
        </>
    );
};

export default DailyCheckIn;